module.exports = __webpack_public_path__ + "img/dfjw3.ea6fcc2c.jpg";